/*
 * @Author: huangshimin@klcxkj.com
 * @Date: 2022-03-28 16:41:39
 * @LastEditors: huangshimin@klcxkj.com
 * @LastEditTime: 2022-04-14 14:27:36
 * @FilePath: \client-h5\src\pages\bindRoom\services.js
 */
import http from '../../utils/http';
//项目下拉
export function projectSelect() {
  return http("get", '/bind/getAllProject');
}
//房间下拉
export function roomSelect(params) {
  return http("get", '/bind/getAreaInfoList',params);
}
//绑定房间
export function bindRoom(params) {
    return http("put", '/bind/bindRoom?roomId='+params.roomId+'&projectId='+params.projectId);
}

